import { render, staticRenderFns } from "./receipt-list.vue?vue&type=template&id=aff3b760&scoped=true&"
import script from "./receipt-list.vue?vue&type=script&lang=ts&"
export * from "./receipt-list.vue?vue&type=script&lang=ts&"
import style0 from "./receipt-list.vue?vue&type=style&index=0&id=aff3b760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff3b760",
  null
  
)

export default component.exports